import { render, staticRenderFns } from "./round.mpx?vue&type=template&id=28e9606c&isComponent&outputPath=components%2Fround08a99fd2%2Findex"
import script from "./round.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fround08a99fd2%2Findex"
export * from "./round.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fround08a99fd2%2Findex"
import style0 from "./round.mpx?vue&type=style&index=0&id=28e9606c&prod&lang=stylus&mpxStyleOptions=%7B%22mid%22%3A%22_08a99fd2%22%7D&isComponent&outputPath=components%2Fround08a99fd2%2Findex"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports